var MDG_DIAGNOSTIC_SCORE_CRITERIA_ORDER, MDG_EPIDEMIOLOGICAL_SCORE_CRITERIA_ORDER_CASE_STUDIES, MDG_EPIDEMIOLOGICAL_SCORE_CRITERIA_ORDER_COHORT_STUDIES, MDG_EPIDEMIOLOGICAL_SCORE_POINTS, MDG_TREATMENT_SCORE_CRITERIA_ORDER, Printout, alt, createPrintoutContainer, exportToFile, getEpidemiologicalScoreCriteriaOrder, getNestedCriteriaKeys, getScoreCriteriaOrder, mdgFormat, mediator, removeHTMLNode, _ref, _ref1,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

alt = require('alt');

mediator = require('mediator');

exportToFile = require('lib/export_to_file').exportToFile;

Printout = MDGTables.Printout;

mdgFormat = require('lib/references_utils').mdgFormat;

_ref = require('lib/mdg_helper'), MDG_TREATMENT_SCORE_CRITERIA_ORDER = _ref.MDG_TREATMENT_SCORE_CRITERIA_ORDER, MDG_DIAGNOSTIC_SCORE_CRITERIA_ORDER = _ref.MDG_DIAGNOSTIC_SCORE_CRITERIA_ORDER, MDG_EPIDEMIOLOGICAL_SCORE_POINTS = _ref.MDG_EPIDEMIOLOGICAL_SCORE_POINTS, MDG_EPIDEMIOLOGICAL_SCORE_CRITERIA_ORDER_CASE_STUDIES = _ref.MDG_EPIDEMIOLOGICAL_SCORE_CRITERIA_ORDER_CASE_STUDIES, MDG_EPIDEMIOLOGICAL_SCORE_CRITERIA_ORDER_COHORT_STUDIES = _ref.MDG_EPIDEMIOLOGICAL_SCORE_CRITERIA_ORDER_COHORT_STUDIES;

_ref1 = require('base/lib/utils'), removeHTMLNode = _ref1.removeHTMLNode, createPrintoutContainer = _ref1.createPrintoutContainer;

getNestedCriteriaKeys = function(criteriaGroups) {
  return criteriaGroups.reduce((function(criterionIds, criteriaByGroup) {
    return criterionIds.concat(criteriaByGroup.keySeq().toArray());
  }), []);
};

getEpidemiologicalScoreCriteriaOrder = function(studies) {
  var allCaseStudies, allCohortStudies, caseStudiesCriteriaOrder, cohortStudiesCriteriaOrder;
  caseStudiesCriteriaOrder = getNestedCriteriaKeys(MDG_EPIDEMIOLOGICAL_SCORE_CRITERIA_ORDER_CASE_STUDIES);
  cohortStudiesCriteriaOrder = getNestedCriteriaKeys(MDG_EPIDEMIOLOGICAL_SCORE_CRITERIA_ORDER_COHORT_STUDIES);
  allCaseStudies = studies.every(function(study) {
    return study.getIn(['score', 'studyType']) === 'case_studies';
  });
  allCohortStudies = studies.every(function(study) {
    return study.getIn(['score', 'studyType']) === 'cohort_studies';
  });
  if (allCaseStudies) {
    return caseStudiesCriteriaOrder;
  }
  if (allCohortStudies) {
    return cohortStudiesCriteriaOrder;
  }
  return _.union(caseStudiesCriteriaOrder, cohortStudiesCriteriaOrder);
};

getScoreCriteriaOrder = function(questionType, studies) {
  switch (questionType) {
    case 'epidemiological':
      return getEpidemiologicalScoreCriteriaOrder(studies);
    case 'treatment':
      return MDG_TREATMENT_SCORE_CRITERIA_ORDER;
    default:
      return MDG_DIAGNOSTIC_SCORE_CRITERIA_ORDER;
  }
};

_.namespace(module, function() {
  return {
    "export": function(i18n, question, studiesForExport, references, exportFormat) {
      var content, printoutContainer, referencesIds, studies;
      printoutContainer = createPrintoutContainer();
      studies = question.get('studies').filter(function(study) {
        var _ref2;
        return _ref2 = study.get('id'), __indexOf.call(studiesForExport, _ref2) >= 0;
      });
      referencesIds = studies.reduce(function(ids, study) {
        return ids.add(study.get('referenceId', null));
      }, Immutable.Set());
      references = references.filter(function(reference) {
        return referencesIds.has(reference.get('_id'));
      });
      content = exportFormat === 'csv' ? this.getCsvContent(question, studies, references, i18n) : this.getPrintoutHTML(question, studies, references, i18n, printoutContainer);
      return exportToFile(exportFormat, content, {
        fileName: question.get('question').substring(0, 100),
        orientation: 'portrait'
      }).then(function() {
        return mediator.dialogs.success({
          message: i18n('/projects:export_dialog.table_export_successful', {
            'tablename': question.get('question')
          }),
          ms: 10000,
          closeBtn: true
        });
      })["catch"](function(reason) {
        if (reason !== 'cancelled') {
          return mediator.dialogs.error(reason);
        }
      })["finally"](function() {
        return removeHTMLNode(printoutContainer);
      });
    },
    getPrintoutHTML: function(question, studies, references, i18n, printoutContainer) {
      var $printout, fakeDoc, meta;
      ReactDOM.render(React.createElement(Printout, {
        type: question.get('type'),
        i18n: function(key, params, componentParams) {
          return i18n("/mdg_tables:tables." + key, params, componentParams);
        },
        references: references.toJS(),
        studies: studies.toJS()
      }), printoutContainer);
      $printout = printoutContainer.querySelector('#mdg-printout');
      fakeDoc = document.implementation.createHTMLDocument('');
      fakeDoc.documentElement.setAttribute('xmlns:v', 'urn:schemas-microsoft-com:vml');
      fakeDoc.documentElement.setAttribute('xmlns:o', 'urn:schemas-microsoft-com:office:office');
      fakeDoc.documentElement.setAttribute('xmlns:w', 'urn:schemas-microsoft-com:office:word');
      fakeDoc.documentElement.setAttribute('xmlns:m', 'http://schemas.microsoft.com/office/2004/12/omml');
      fakeDoc.documentElement.setAttribute('xmlns', 'http://www.w3.org/TR/REC-html40');
      meta = document.createElement('meta');
      meta.setAttribute("charset", "UTF-8");
      meta.setAttribute("http-equiv", "X-UA-Compatible");
      meta.setAttribute("content", "IE=edge,chrome=1");
      fakeDoc.head.append(meta);
      fakeDoc.body.innerHTML = $printout.outerHTML;
      return '<!doctype html>' + fakeDoc.documentElement.outerHTML;
    },
    getCsvContent: function(question, studies, references, i18n) {
      var CRITERIA_ORDER, dataRows, headerRows, questionType;
      CRITERIA_ORDER = getScoreCriteriaOrder(question.get('type'), studies);
      questionType = question.get('type');
      headerRows = [
        [''].concat(CRITERIA_ORDER.map(function(key) {
          return i18n("/mdg_tables:edit_form.score.criteria." + key);
        })).concat([i18n("/mdg_tables:edit_form.score.value")])
      ];
      dataRows = studies.map(function(study) {
        var criteria, excludedFromScoring, reference, scoreColumns;
        reference = references.find(function(reference) {
          return reference.get('_id') === study.get('referenceId');
        });
        excludedFromScoring = study.getIn(['score', 'excludedFromScoring'], false);
        criteria = questionType === 'epidemiological' ? study.getIn(['score', 'epidemiologicalCriteria'], Immutable.Map()).map(function(criterionScore, criterionId) {
          var points;
          points = criterionScore.reduce(function(sum, criterionValue) {
            return sum + (MDG_EPIDEMIOLOGICAL_SCORE_POINTS[criterionValue] || 0);
          }, 0);
          if (excludedFromScoring) {
            return '-';
          } else if (criterionScore != null) {
            return points;
          } else {
            return 0;
          }
        }).toJS() : study.getIn(['score', 'criteria'], Immutable.Map()).toJS();
        scoreColumns = CRITERIA_ORDER.map(function(criterionId) {
          var criterionScore;
          criterionScore = criteria[criterionId];
          if (excludedFromScoring) {
            return '-';
          } else {
            return criterionScore != null ? criterionScore : 0;
          }
        });
        return [mdgFormat((reference || Immutable.Map()).toJS()) || i18n('/projects:export_dialog.no_reference_assigned')].concat(scoreColumns).concat([study.getIn(['score', 'value'], '')]);
      });
      return headerRows.concat(dataRows.toJS()).map(function(row) {
        return row.map(function(cell) {
          var value;
          value = cell != null ? cell : '';
          if (typeof value === 'string') {
            return '"' + value.replace(/"/g, '""') + '"';
          } else {
            return value;
          }
        }).join(';');
      }).join('\n');
    },
    openInNewWindow: function(i18n, question) {
      var $printout, el, printoutContainer, references, tableContainer, tableWindowRef, title;
      printoutContainer = createPrintoutContainer();
      references = alt.stores.ReferencesStore.getReferences();
      ReactDOM.render(React.createElement(Printout, {
        type: question.get('type'),
        i18n: function(key, params, componentParams) {
          return i18n("/mdg_tables:tables." + key, params, componentParams);
        },
        references: references.toJS(),
        studies: question.get('studies').toJS()
      }), printoutContainer);
      $printout = printoutContainer.querySelector('#mdg-printout');
      tableWindowRef = window.open('about:blank', "_blank", 'resizable=yes, scrollable=yes, status=yes, menubar=no');
      if (tableWindowRef) {
        tableWindowRef.opener = null;
        el = document.createElement('div');
        title = document.createElement('h3');
        title.innerHTML = question.get('question');
        tableContainer = document.createElement('div');
        tableContainer.innerHTML = $printout.innerHTML;
        el.appendChild(title);
        el.appendChild(tableContainer);
        return tableWindowRef.document.body.appendChild(el);
      }
    }
  };
});
